import React from 'react'
import styled from 'styled-components'

const Container = styled('div')`
  text-align: left;
  color: #1e1e1e;
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.9px;
  text-transform: uppercase;
  margin-top: 36px;
  margin-bottom: 12px;
`

const SubQuestionTitle = ({ subQuestion }) => {
  return <Container>{subQuestion}</Container>
}

export default SubQuestionTitle
